export type ServiceColumnsMap = Record<string, string[] | Record<string, string[]>>;

export const ORDER_SERVICE_KEYS = ['trademark', 'patent', 'copyright', 'company', 'barcode', 'other'] as const;
export type OrderServiceKey = typeof ORDER_SERVICE_KEYS[number];

export const ORDER_SERVICE_LABELS: Record<OrderServiceKey, string> = {
  trademark: '商标服务',
  patent: '专利服务',
  copyright: '版权服务',
  company: '工商服务',
  barcode: '条码服务',
  other: '其他服务',
};

// 全部共用字段，每个业务和子业务中都有的字段
export const start_columns = ['nation', 'status', 'next_status', 'sub_service', 'order_no', 'case_no', 'user_id', 'client_id'];
export const end_columns = [ 'receipt_at', 'announcement_at', 'decline_at', 'approve_at', 'payment_status', 'payment_at', 'price', 'cost', 'profit', 'due_at', 'expiration_at', 'group_number', 'commission', 'remark', 'created_at', 'updated_at', 'contact_name', 'client_email', 'client_type', 'seller', 'source','channel', 'files'];

export const ORDER_BASE_COLUMNS = Array.from(new Set([
  'id',
  'order_type',
  'parent_id',
  'service',
  ...start_columns,
  'applicant_name',
  'applicant_address',
  'applicant_name_en',
  'applicant_address_en',
  'application_entity_type',
  'client_email',
  'client_type',
  'contact_name',
  'notification_emails',
  'customer_categories',
  'phone',
  ...end_columns,
]));

// 各服务的列映射：_default + 子业务键 → 列 key 数组
export const SERVICE_COLUMNS_MAP: ServiceColumnsMap = {
  all:{
    _default: [
      'service',
      ...start_columns,
      ...end_columns,
    ],
  },
  trademark: {
    _default: [
      ...start_columns,
       'trademark_name', 'trademark_image', 'application_no', 'primary_class', 'sub_class',
      ...end_columns,
    ],
    registration: [
      ...start_columns,
      'trademark_name', 'trademark_image', 'primary_class', 'sub_class', 'application_no', 'registration_no', 'application_entity_type', 'applicant_name', 'applicant_address', 'applicant_name_en', 'applicant_address_en', 'priority', 'application_basics', 'a1_first_use_at', 'a1_first_commercial_use_at', 'b44_registration_no', 'b44_registration_at', 'd44_application_no', 'd44_application_at', 'trademark_meaning', 'color_statement', 'trademark_type',
      ...end_columns,
    ],
    transactions: [
      ...start_columns,
      'trademark_name', 'trademark_image', 'trademark_type', 'primary_class', 'sub_class', 'application_no', 'registration_no', 'assignee_entity_type', 'assignee_name', 'assignee_address', 'assignee_name_en', 'assignee_address_en', 'include_transfer_service', 'application_entity_type', 'applicant_name', 'applicant_address', 'applicant_name_en', 'applicant_address_en',
      ...end_columns,
    ],
    extension: [
      ...start_columns,
      'trademark_name', 'trademark_image', 'sub_class', 'application_no', 'postpone_type', 'postpone_times', 'postpone_reason', 'applicant_name', 'applicant_name_en',
      ...end_columns,
    ],
    postpone_evidence: [
      ...start_columns,
      'trademark_name', 'trademark_image', 'application_no', 'primary_class', 'sub_class', 'applicant_name', 'applicant_name_en',
      ...end_columns,
    ],
    transfer: [
      ...start_columns,
      'trademark_name', 'trademark_image', 'primary_class', 'sub_class', 'trademark_status', 'assignment_type', 'application_no', 'registration_no', 'assignee_name', 'assignee_name_en', 'assignee_address', 'assignee_address_en', 'applicant_name', 'applicant_address', 'applicant_name_en', 'applicant_address_en',
      ...end_columns,
    ],
    review: [
      ...start_columns,
      'trademark_name', 'trademark_image', 'sub_class', 'application_no', 'registration_no', 'review_type', 'review_times', 'rationale_basis', 'applicant_name', 'applicant_name_en',
      ...end_columns,
    ],
    revocation: [
      ...start_columns,
      'trademark_name', 'trademark_image', 'sub_class', 'application_no', 'registration_no', 'revocation_type', 'rationale_basis','applicant_name', 'applicant_name_en',
      ...end_columns,
    ],
    search: [
      ...start_columns,
      'trademark_name', 'trademark_image', 'primary_class', 'sub_class', 'search_method',
      ...end_columns,
    ],
    oath: [
      ...start_columns,
      'trademark_name', 'trademark_image', 'registration_no', 'primary_class', 'sub_class', 'oath_type', 'applicant_name', 'applicant_name_en',
      ...end_columns,
    ],
    renewal: [
      ...start_columns,
      'trademark_name', 'trademark_image', 'registration_no', 'primary_class', 'sub_class', 'renewal_period', 'applicant_name', 'applicant_name_en',
      ...end_columns,
    ],
    agency_transfer: [
      ...start_columns,
      'trademark_name', 'trademark_image', 'primary_class', 'sub_class', 'application_no', 'registration_no', 'original_agent', 'applicant_name', 'applicant_name_en',
      ...end_columns,
    ],
    cancellation: [
      ...start_columns,
      'trademark_name', 'trademark_image', 'application_no', 'registration_no', 'primary_class', 'sub_class', 'cancellation_reason', 'applicant_name', 'applicant_name_en',
      ...end_columns,
    ],
    certificate_reissue: [
      ...start_columns,
      'trademark_name', 'trademark_image', 'registration_no', 'primary_class', 'sub_class', 'certificate_type', 'applicant_name', 'applicant_name_en',
      ...end_columns,
    ],
    information_changes: [
      ...start_columns,
      'trademark_name', 'trademark_image', 'application_no', 'registration_no', 'primary_class', 'sub_class', 'applicant_name', 'applicant_address', 'applicant_name_en', 'applicant_address_en', 'new_applicant_name', 'new_applicant_name_en', 'new_applicant_address', 'new_applicant_address_en', 'change_items',
      ...end_columns,
    ],
    investment: [
      ...start_columns,
      'trademark_name', 'trademark_image', 'trademark_type', 'application_no', 'registration_no', 'sale_status', 'sold_at', 'primary_class', 'sub_class', 'applicant_name', 'applicant_address', 'applicant_name_en', 'applicant_address_en',
      ...end_columns,
    ],
  },
  madrid: [
    ...start_columns,
    'trademark_name', 'trademark_image', 'application_no', 'registration_no', 'international_registration_no', 'primary_class', 'sub_class', 'application_entity_type', 'applicant_name', 'applicant_address', 'applicant_name_en', 'applicant_address_en',
    ...end_columns,
  ],
  patent: {
    _default: [
      ...start_columns,
      'patent_name', 'entity_type',
      ...end_columns,
    ],
    appearance_application: [
      ...start_columns,
      'patent_name', 'application_no', 'registration_no', 'include_drawing', 'accelerated', 'include_authorization', 'include_translation', 'entity_type', 'priority', 'priority_no', 'open_status', 'opened_at', 'opened_area', 'opened_type', 'application_entity_type', 'applicant_name', 'applicant_address', 'applicant_name_en', 'applicant_address_en', 'inventor_name', 'inventor_name_en', 'inventor_address', 'inventor_address_en',
      ...end_columns,
    ],
    invention_application: [
      ...start_columns,
      'patent_name', 'application_no', 'registration_no', 'claims_count', 'exceeding_quantity', 'include_document_writing', 'accelerated', 'include_authorization', 'include_translation', 'entity_type', 'priority', 'priority_no', 'open_status', 'opened_at', 'opened_area', 'opened_type', 'application_entity_type', 'applicant_name', 'applicant_address', 'applicant_name_en', 'applicant_address_en', 'inventor_name', 'inventor_name_en', 'inventor_address', 'inventor_address_en',
      ...end_columns,
    ],
    utility_application: [
      ...start_columns,
      'patent_name', 'application_no', 'registration_no', 'claims_count', 'exceeding_quantity', 'include_document_writing', 'accelerated', 'include_authorization', 'include_translation', 'entity_type', 'priority', 'priority_no', 'open_status', 'opened_at', 'opened_area', 'opened_type', 'application_entity_type', 'applicant_name', 'applicant_address', 'applicant_name_en', 'applicant_address_en', 'inventor_name', 'inventor_name_en', 'inventor_address', 'inventor_address_en',
      ...end_columns,
    ],
    authorization: [
      ...start_columns,
      'patent_type', 'patent_name', 'application_no', 'registration_no', 'entity_type', 'applicant_name', 'applicant_name_en',
      ...end_columns,
    ],
    rejection_review: [
      ...start_columns,
      'application_no', 'registration_no', 'review_type', 'rejection_reason', 'postpone_times', 'applicant_name', 'applicant_name_en',
      ...end_columns,
    ],
  },
  copyright: {
    _default: [
      ...start_columns,
      'application_no', 'registration_no', 'work_name', 'open_status', 'opened_area', 'opened_at', 'opened_type', 'application_type', 'application_category', 'work_inspiration', 'applicant_name', 'applicant_name_en', 'applicant_address', 'applicant_address_en', 'assignee_name', 'assignee_name_en', 'assignee_address', 'assignee_address_en',
      ...end_columns,
    ],
    registration: [
      ...start_columns,
      'application_no', 'registration_no', 'work_name', 'open_status', 'opened_at', 'opened_area', 'opened_type', 'application_type', 'application_type', 'application_category', 'work_inspiration', 'applicant_name', 'applicant_address', 'applicant_name_en', 'applicant_address_en',
      ...end_columns,
    ],
    transfer: [
      ...start_columns,
      'work_name', 'application_category', 'application_no', 'registration_no', 'applicant_name', 'applicant_name_en', 'applicant_address', 'applicant_address_en', 'assignee_name', 'assignee_name_en', 'assignee_address', 'assignee_address_en',
      ...end_columns,
    ],
  },
  company: {
    _default: [
      ...start_columns,
      'company_name', 'company_no', 'company_address', 'company_type', 'legal_representative', 'include_vat_no', 'include_bank_account', 'include_foreign_directors', 'annual_inspection_times', 'account_bank', 'cancellation_reason', 'change_items',
      ...end_columns,
    ],
    registration: [
      ...start_columns,
      'company_name', 'company_address', 'company_no', 'company_type', 'legal_representative', 'include_vat_no', 'include_bank_account', 'include_foreign_directors',
      ...end_columns,
    ],
    annual_review: [
      ...start_columns,
      'company_name', 'company_address', 'company_no', 'company_type', 'legal_representative', 'annual_inspection_times',
      ...end_columns,
    ],
    audit: [
      ...start_columns,
      'company_name', 'company_address', 'company_no', 'company_type', 'legal_representative', 'annual_inspection_times',
      ...end_columns,
    ],
    bank_account_opening: [
      ...start_columns,
      'company_name', 'company_no', 'account_bank',
      ...end_columns,
    ],
    cancellation: [
      ...start_columns,
      'company_name', 'company_no', 'cancellation_reason',
      ...end_columns,
    ],
    information_changes: [
      ...start_columns,
      'company_name', 'company_no', 'change_items',
      ...end_columns,
    ],
  },
  barcode: {
    _default: [
      ...start_columns,
      'registration_no', 'quantity', 'company_name',
      ...end_columns,
    ],
    registration: [
      ...start_columns,
      'quantity', 'validity_period', 'registration_no', 'company_name',
      ...end_columns,
    ],
    renewal: [
      ...start_columns,
      // 条形码续费沿用订单列表公共尾部字段，避免子业务列设置被截断。
      'quantity', 'renewal_period', 'registration_no', 'company_name',
      ...end_columns,
    ],
    cancellation: [
      ...start_columns,
      'quantity', 'registration_no', 'company_name', 'cancellation_reason',
      ...end_columns,
    ],
    increase: [
      ...start_columns,
      'quantity_original', 'quantity_increase', 'registration_no', 'company_name',
      ...end_columns,
    ],
  },
  other: {
    _default: [
      'nation', 'status', 'service_name', 'order_no',
      ...end_columns,
    ],
    registration: [
      'nation', 'status', 'service_name', 'order_no',
      ...end_columns,
    ],
  }
};

// 获取某服务（或全部）下所有子业务列 key 的并集，供表单/列设置等使用
export function getServiceColumnsUnion(service: string | 'all' = 'all'): string[] {
  const union = new Set<string>();

  const collect = (val: string[] | Record<string, string[]>) => {
    if (Array.isArray(val)) {
      val.forEach(k => union.add(k));
    } else if (val && typeof val === 'object') {
      Object.values(val).forEach(arr => {
        if (Array.isArray(arr)) arr.forEach(k => union.add(k));
      });
    }
  };

  if (service === 'all') {
    Object.values(SERVICE_COLUMNS_MAP).forEach(collect);
  } else if (SERVICE_COLUMNS_MAP[service]) {
    collect(SERVICE_COLUMNS_MAP[service]);
  }

  return Array.from(union);
}

export function isOrderBaseColumn(column: string): boolean {
  return ORDER_BASE_COLUMNS.includes(column);
}

export function getOrderExtensionColumnsByService(service: OrderServiceKey): string[] {
  const sourceKeys = service === 'trademark' ? ['trademark', 'madrid'] : [service];
  const columns = new Set<string>();

  sourceKeys.forEach((sourceKey) => {
    getServiceColumnsUnion(sourceKey).forEach((column) => {
      if (!isOrderBaseColumn(column)) {
        columns.add(column);
      }
    });
  });

  return Array.from(columns);
}

export function getOrderFieldServiceKeys(field: string): OrderServiceKey[] {
  if (isOrderBaseColumn(field)) {
    return [];
  }

  return ORDER_SERVICE_KEYS.filter((service) => getOrderExtensionColumnsByService(service).includes(field));
}
